import { render, staticRenderFns } from "./shipment-rules-modal-basic-form.vue?vue&type=template&id=3844ccc0&scoped=true&"
import script from "./shipment-rules-modal-basic-form.ts?vue&type=script&lang=ts&"
export * from "./shipment-rules-modal-basic-form.ts?vue&type=script&lang=ts&"
import style0 from "./shipment-rules-modal-basic-form.scss?vue&type=style&index=0&id=3844ccc0&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3844ccc0",
  null
  
)

export default component.exports